<template>
  <div class="p-2">
    <b-overlay :show="isLoading" rounded="sm">
      <div class="">
        <b-row>
          <b-col cols="12" md="12">
            <b-form-group label-for="biography" :label-cols="12">
              <h6 class="d-flex">
                {{ $lang.Personal_biography }}
              </h6>

              <b-form-textarea
                id="biography"
                :state="$v.biography.$dirty ? !$v.biography.$error : null"
                v-model="$v.biography.$model"
                type="text"
                :autocomplete="$lang.biography"
                :rows="6"
              >
              </b-form-textarea>
              <b-form-invalid-feedback id="biography-feedback">
                {{ $lang.error_required | replace($lang.Personal_biography) }}
              </b-form-invalid-feedback>

              <b-form-invalid-feedback
                v-if="$v.biography.$error"
                id="name-feedback"
              >
                {{
                  $lang.error_Value
                    .replace("{0}", $lang.Personal_biography)
                    .replace("{1}", "25")
                    .replace("{2}", "500")
                }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="12">
            <b-form-group label-for="favorites" :label-cols="12">
              <h6>{{ $lang.favorites }}</h6>
              <requiredComponent slot="label" :rules="$v.favorites.$params" />
              <b-form-textarea
                id="favorites"
                :state="$v.favorites.$dirty ? !$v.favorites.$error : null"
                v-model="$v.favorites.$model"
                type="text"
                :autocomplete="$lang.favorites"
                :rows="6"
              >
              </b-form-textarea>
              <b-form-invalid-feedback id="favorites-feedback">
                {{ $lang.error_required | replace($lang.favorites) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="12">
            <b-form-group label-for="final_introduction" :label-cols="12">
              <h6>{{ $lang.final_introduction }}</h6>
              <requiredComponent
                slot="label"
                :rules="$v.final_introduction.$params"
              />
              <b-form-textarea
                id="final_introduction"
                :state="
                  $v.final_introduction.$dirty
                    ? !$v.final_introduction.$error
                    : null
                "
                v-model="$v.final_introduction.$model"
                type="text"
                :autocomplete="$lang.final_introduction"
                :rows="6"
              >
              </b-form-textarea>
              <b-form-invalid-feedback id="final_introduction-feedback">
                {{ $lang.error_required | replace($lang.final_introduction) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="12" v-if="checkCustomKey('isConvictionHistory')">
            <b-form-group label-for="conviction_history" :label-cols="12">
              <h6>{{ $lang.conviction_history }}</h6>
              <requiredComponent
                slot="label"
                :rules="$v.conviction_history.$params"
              />
              <b-form-textarea
                id="conviction_history"
                :state="
                  $v.conviction_history.$dirty
                    ? !$v.conviction_history.$error
                    : null
                "
                v-model="$v.conviction_history.$model"
                type="text"
                :autocomplete="$lang.conviction_history"
                :rows="6"
              >
              </b-form-textarea>
              <b-form-invalid-feedback id="conviction_history-feedback">
                {{ $lang.error_required | replace($lang.conviction_history) }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col cols="12" class="my-2">
          <b-button
            v-if="isAdmin(parentPermissions)"
            @click="save"
            class="float-right"
            variant="success"
            :disabled="isLoading"
          >
            <div v-if="!isLoading">
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </div>
            <div v-if="isLoading">
              <b-spinner small></b-spinner>
              <span> {{ $lang.submit_loading }}</span>
            </div>
          </b-button>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { isAdmin, checkCustomKey } from "@/shared/utils";

export default {
  name: "other-person-page",
  validations: {
    biography: {
      required,
      minLength: minLength(25),
      maxLength: maxLength(3000),
    },
    favorites: {},
    final_introduction: {},
    conviction_history: {},
  },
  props: {
    item: {
      type: Object,
    },
    step: {
      type: Object,
    },
    currentstep: {
      type: [String, Number],
    },
    stepcount: {
      type: [String, Number],
    },
    code: {
      type: String,
    },
    state: {
      type: String,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      biography: null,
      favorites: null,
      final_introduction: null,
      conviction_history: null,
      isLoading: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    isAdmin,
    checkCustomKey,
    nextStep() {
      this.$emit("step-change", "attachment", this.state);
    },

    lastStep() {
      this.$emit("step-change", "acquaintances");
    },
    fetchData() {
      this.isLoading = true;
      this.favorites = this.item.favorites;
      this.final_introduction = this.item.final_introduction;
      this.biography = this.item.biography;
      this.conviction_history = this.item.conviction_history;
      this.isLoading = false;
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.isLoading = true;
        const payload = {
          biography: this.biography,
          favorites: this.favorites,
          final_introduction: this.final_introduction,
          conviction_history: this.conviction_history,
        };
        const url =
          this.$config.api_url +
          this.$config.resources.person_text.replace("{0}", this.code);
        await this.$httpService.patch(url, payload);
        this.$emit("getProfile");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
